import {
  TableComponent,
  ImageComponent,
} from "@kontent-ai/rich-text-resolver/utils/react";
import type { Elements } from "@kontent-ai/delivery-sdk";
import { transformToPortableText } from "@kontent-ai/rich-text-resolver";
import { richText } from "types/CMS/Unum/richText";
import DOMPurify from "dompurify";
import { createResolver } from "./Factories/ResolverFactory";

// assumes richTextElement from SDK

export const richTextResolver = createResolver({
  resolve: (element: Elements.RichTextElement): richText => {
    return {
      type: "richText",
      value: transformToPortableText(element.value),
      compontents: {
        types: {
          componentOrItem: ({ value }) => {
            const item = element.linkedItems.find(
              (item) => item.system.codename === value?.componentOrItem._ref
            );

            return <div>{item?.elements.text_element.value}</div>;
          },
          // Image and Table components are used as a default fallback if a resolver isn't explicitly specified
          table: ({ value }) => <TableComponent {...value} />,
          image: ({ value }) => <ImageComponent {...value} />,
        },
        marks: {
          link: ({ value, children }) => {
            return (
              <a
                href={DOMPurify.sanitize(value?.href ?? "", {
                  ALLOWED_URI_REGEXP: /^(https?:\/\/|mailto:|tel:)/i,
                })}
                rel={value?.rel}
                title={value?.title}
                data-new-window={value?.["data-new-window"]}
              >
                {children}
              </a>
            );
          },
          contentItemLink: ({ value, children }) => {
            const item = element.linkedItems.find(
              (item) => item.system.id === value?.contentItemLink._ref
            );
            const baseUrl = process.env.REACT_APP_BASE_URL ?? "";
            return <a href={baseUrl + item?.system.codename}>{children}</a>;
          },
        },
      },
    };
  },
});
